// extracted by mini-css-extract-plugin
module.exports = {"white-space":"scroll_white-space__1feDM","font-size-18":"scroll_font-size-18__1GzkV","max-width-300":"scroll_max-width-300__1hlwH","padding-0-10":"scroll_padding-0-10__eSh_p"};